import Big from "big.js";
import { InnerLabelTextfield, TextField } from "components/commons";
import React from "react";
import { isPesoValid, formatNumber, isAmountValid } from "utils";
import { removeComasStringAmount } from "utils/text.utils";

const InputAmount = ({
  className,
  onChange,
  innerLabel,
  decimalPlaces = 2,
  isPriceValue = false,
  prefix = "₱",
  onBlur,
  ...props
}) => {
  const [isFocused, setIsFocused] = React.useState(false);

  const displayValue = (() => {
    const raw = props.value;
    if (isFocused || raw === "" || raw === undefined || raw === null) return raw;
    const stripped = removeComasStringAmount(String(raw));
    return isNaN(Number(stripped)) ? raw : formatNumber(stripped, decimalPlaces);
  })();

  const componentProps = {
    ...props,
    value: displayValue,
    className,
    onChange: (name, { value }) => {
      const min = props?.min;
      const max = props?.max;

      if (value === "") {
        onChange(name, { value });
        return;
      }

      if (value === "-" && (min === undefined || +min < 0)) {
        onChange(name, { value });
        return;
      }

      if (decimalPlaces === 0 && value.includes(".")) {
        onChange(name, { value: props.value ?? "" });
        return;
      }

      if (value.includes(".")) {
        const decimalPart = value.split(".")[1];
        if (decimalPart && decimalPart.length > decimalPlaces) {
          onChange(name, { value: props.value ?? "" });
          return;
        }
      }

      const parsed = Number(value);
      if (isNaN(parsed)) {
        onChange(name, { value: props.value ?? "" });
        return;
      }

      if (max !== undefined) {
        const bigValue = new Big(value);
        const bigMax = new Big(max);
        if (bigValue.gt(bigMax)) {
          onChange(name, { value: props.value ?? "" });
          return;
        }
      }
      if (min !== undefined && parsed < +min) {
        onChange(name, { value: props.value ?? "" });
        return;
      }

      const isValid = isPriceValue
        ? isAmountValid(value, decimalPlaces)
        : isPesoValid(value, decimalPlaces);

      if (isValid || !isPriceValue) {
        onChange(name, { value });
      }
    },
    onBlur: (name, { value }) => {
      setIsFocused(false);
      if (isNaN(value)) {
        return onChange(name, {
          value: "",
        });
      }

      if (onBlur) {
        onBlur(value);
      } else {
        if (value) {
          onChange(name, {
            value: `${formatNumber(value, decimalPlaces)}${!innerLabel ? "" : ""}`,
          });
        } else {
          onChange(name, { value: `${formatNumber(0, decimalPlaces)}` });
        }
      }
    },
    onFocus: () => {
      setIsFocused(true);
      if (props.value) {
        const num = removeComasStringAmount(props.value);
        onChange(props.name, { value: num || "" });
      }
    },
  };
  if (innerLabel) {
    return <InnerLabelTextfield {...componentProps} prefix={prefix} />;
  }
  return <TextField {...componentProps} />;
};

export default InputAmount;
